import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {HostingService} from "../hosting.service";
import * as fromStore from "../../../../store/";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";

@Injectable()
export class HostingInfoResolver implements Resolve<null> {

  constructor(
    private _hostingService: HostingService,
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data && route.parent.data['website'] ? route.parent.data['website'].id : route.parent.parent.data['website'].id;
      const _childWebsiteId = route.parent.data['website'] && route.parent.data['website'].isNetwork && !route.parent.data['website'].parentId && route.parent.data['website'].children && route.parent.data['website'].children.length ? route.parent.data['website'].children[0] : null;

      this._store.select(fromStore.getInfoLoaded(_childWebsiteId || websiteId))
        .pipe(
          filter((loaded: boolean) => !!loaded),
          switchMap(() => this._store.select(fromStore.getInfo(_childWebsiteId || websiteId))),
          first()
        )
        .subscribe((hostingInfo: any): void => {
          if (hostingInfo) {
            resolve(hostingInfo);
          }
          else {
            resolve(null);
          }
        });
      /*this._hostingService.getHostingInfoData(websiteId)
        .filter((response: DbResponse): boolean => !!response)
        .first()
        .subscribe((response) => {
          if (response.success) {
            resolve(response.data);
          }
          else {
            resolve(null);
          }
        });*/
    });
  }

}
